import { Builder } from '@builder.io/react'
import { IconGridItem } from './iconGridItem'

type IconGridItem = {
  icon: string
  label: string
  href: string
  iconWidth?: number
  iconHeight?: number
}

type IconGridProps = {
  items: IconGridItem[]
  columns?: number
  columnGap?: number
  rowGap?: number
  stackOnMobile?: boolean
}

const columnClasses: { [key: number]: string } = {
  1: `grid-cols-1`,
  2: `grid-cols-2`,
  3: `grid-cols-3`,
  4: `grid-cols-4`,
  5: `grid-cols-5`,
  6: `grid-cols-6`
}

const mdColumnClasses: { [key: number]: string } = {
  1: `md:grid-cols-1`,
  2: `md:grid-cols-2`,
  3: `md:grid-cols-3`,
  4: `md:grid-cols-4`,
  5: `md:grid-cols-5`,
  6: `md:grid-cols-6`
}

export const IconGrid = ({
  items = [],
  columns = 3,
  columnGap = 24,
  rowGap = 24,
  stackOnMobile = false
}: IconGridProps ) => {

  const gridClass = stackOnMobile
    ? `grid grid-cols-1 ${mdColumnClasses[columns]}`
    : `grid ${columnClasses[columns]}`

  return (
    <div
      className={`${gridClass}`}
      style={{
        columnGap: `${columnGap}px`,
        rowGap: `${rowGap}px`
      }}
    >
      {items.map( ( item ) => (
        <IconGridItem key={`${item.label}-${item.href}`} {...item} />
      ) )}
    </div>
  )
}

Builder.registerComponent( IconGrid, {
  name: `Icon Grid`,
  inputs: [
    {
      name: `items`,
      type: `list`,
      subFields: [
        {
          name: `icon`,
          type: `file`,
          allowedFileTypes: [ `jpeg`, `jpg`, `png`, `svg`, `webp` ]
        },
        {
          name: `label`,
          type: `text`
        },
        {
          name: `href`,
          type: `url`
        },
        {
          name: `iconWidth`,
          type: `number`,
          defaultValue: 48,
          helperText: `Icon width in pixels`
        },
        {
          name: `iconHeight`,
          type: `number`,
          defaultValue: 48,
          helperText: `Icon height in pixels`
        }
      ]
    },
    {
      name: `columns`,
      type: `number`,
      defaultValue: 3,
      helperText: `Number of colums (1-6), default is 3`,
      min: 1,
      max: 6
    },
    {
      name: `stackOnMobile`,
      type: `boolean`,
      defaultValue: true
    },
    {
      name: `columnGap`,
      type: `number`,
      defaultValue: 24,
      helperText: `Horizontal gap in pixels`
    },
    {
      name: `rowGap`,
      type: `number`,
      defaultValue: 24,
      helperText: `Vertical gap in pixels`
    }
  ]
})

export default IconGrid
